import { Media } from "../../../types/media";
import { useTranslation } from "@coworker/locales";
import { CardFrame, FullLine, PaddedContainer } from "../../../styles/styles";
import { CardHeadLine } from "../../../Molecules/Settings/CardHeadLine";
import { MediaImagesListItem } from "../../../Molecules/MediaImagesListItem";
import { MediaTypes } from "../../../constants";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";

interface ImagesSectionProps {
  media: Media;
  images: NewOrExistingFile[];
  onImagesChange: (newImages: NewOrExistingFile[]) => void;
  onImageUpdate: (image: NewOrExistingFile) => void;
}

export const ImagesSection = ({
  media,
  images,
  onImagesChange,
  onImageUpdate,
}: ImagesSectionProps) => {
  const { t } = useTranslation();

  return (
    <CardFrame>
      <CardHeadLine character={"4"} headline={t("addImagesString")} />
      <FullLine />
      {media.mediaType !== MediaTypes.NONE && (
        <PaddedContainer $py="0px" $px="24px">
          <MediaImagesListItem
            media={media}
            images={images}
            onImagesChange={onImagesChange}
            onUpdate={onImageUpdate}
          />
        </PaddedContainer>
      )}
    </CardFrame>
  );
};
